<section fxLayout="column" fxFlex>
  <vdw-header
    [title]="'ANGULAR_COMPONENT_LIBRARY.COLOR_PICKER.CREATE_OBJECT' | bmsTranslate: {object: 'ANGULAR_COMPONENT_LIBRARY.COLOR_PICKER.COLOR' | bmsTranslate: {count: 1} | lowercase}"
    svgIcon="add-blue"
  ></vdw-header>
  <vdw-add-color fxFlex class="dialog-content" #addColor [colorToSave]="selectedColor" (save)="colorCreated($event)" [canEdit]="canEdit" [validatorFunction]="validatorFunction"> </vdw-add-color>
  <vdw-footer [centered]="true" (chooseEvent)="addColor.saveColor()" [chooseEventName]="'ANGULAR_COMPONENT_LIBRARY.COLOR_PICKER.CREATE'"></vdw-footer>
</section>
